import { Checkbox, CheckboxProps } from "antd";
import { useState } from "react";

type Props = { label: string; value: string | number };
const statusColors: any = {
  done: "#479821", // Green
  active: "#479821", // Green
  completed: "#479821", // Green
  cancel: "#C43535", // Red
  blocked: "#C43535", // Red
  canceled: "#C43535", // Red
  pending: "#CF953D", // Yellow
  "In Progress": "#CF953D", // Yellow
  "in progress": "#CF953D", // Yellow
  "in-progress": "#CF953D", // Yellow
  upcoming: "#00086D",
  default: "#00086D", // Blue for other statuses
};
const getColor = (value: string | number): string => {
  if (typeof value === "string") {
    return statusColors[value.toLowerCase()] || statusColors.default;
  }
  return statusColors.default;
};
const StatusItemForm = ({ label, value }: Props) => {
  const [isChecked, setIsChecked] = useState(false);
  const onChange: CheckboxProps["onChange"] = (e) => {
    console.log("checked = ", e.target.checked);
    setIsChecked(e.target.checked);
  };
  const color = getColor(value);
  return (
    <Checkbox
      style={{
        backgroundColor: isChecked ? color : "white",
        color: isChecked ? "white" : color,
        border: `solid 1px ${color}`,
      }}
      className={`rounded-lg px-2 py-1 flex items-center`}
      value={value}
      checked={isChecked}
      onChange={onChange}
    >
      <div className="flex items-center gap-1">
        <div
          className="flex items-center w-2 h-2 rounded-full"
          style={{ backgroundColor: isChecked ? "white" : color }}
        />
        <span className="flex items-center text-sm font-medium">{label}</span>
      </div>
    </Checkbox>
  );
};

export default StatusItemForm;
